import { AuthClientConfig } from '@trumpf-uxlabs/ng-app-auth';
import { AuthConfig } from '../../environments/environment.model';

export function createAuthClientConfig(auth?: AuthConfig): AuthClientConfig {
    return {
        clientId: auth?.clientId || '',
        issuer: auth?.issuer || 'https://account-s.trumpf.com',
        scope: auth?.scope || 'openid',
        defineCustomElements: true,
        // Must stay enabled: AppAuthService.refresh() renews via the active-session iframe,
        // which is only rendered when check-session is on. Salesforce access tokens expire
        // (~5 min) while the IdP session stays valid; on-demand renew in SalesforceAuthService
        // calls refresh() before API calls when the JWT is near expiry.
        // Note: on localhost, browser extensions can interfere with sessionTracker postMessage.
        checkSessionEnabled: true,
    };
}
